import { useEffect, useState } from 'react'
import './Countries.scss'
import { Grid, GridColumn, GridPageChangeEvent } from '@progress/kendo-react-grid'
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'
import { PaisJefe } from '../../models/paisJefe.model';
import { PaisesService } from '../../services/paises.service';
import Loading from '../shared/loading/Loading.component';

interface PageState {
    skip: number;
    take: number;
}
const initialDataState: PageState = { skip: 0, take: 10 };

export const Countries = () => {
    const paisesService = PaisesService({ locale: 'en' });
    const [page, setPage] = useState<PageState>(initialDataState);
    const [paisesJefe, setPaisesJefe] = useState<PaisJefe[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    useEffect(() => {
        getCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const pageChange = (event: GridPageChangeEvent) => {
        setPage(event.page);
    };
    function getCountries() {
        setLoading(true)
        paisesService.getPaisesConJefe().then(resp => {
            const { data } = resp
            data.map(x => {
                if(x.optimisticLockField) {
                    x.active = 'Si'
                } else if (x.optimisticLockField === false) {
                    x.active = 'No'
                } else {
                    x.active = undefined
                }
                return(x)
            })
            setPaisesJefe(resp.data)
            setLoading(false)
        });
    }
    function editCountry(props: any) {
        const { oidJefeEquipo } = props.dataItem
        return (
            <td>
                <Link to={`/admin-users/countries/${oidJefeEquipo}`}>
                    <FontAwesomeIcon className='editIcon' icon={faPenToSquare}></FontAwesomeIcon>
                </Link>
            </td>
        )
    }
    const renderAutoIncrementCell = (props: any) => {
        const index = paisesJefe.findIndex((item) => item.oidJefeEquipo === props.dataItem.oidJefeEquipo);
        return <td>{index + 1}</td>;
    };
    return (
        <>
            {loading ? (
                <div className="loading-comp">
                    <Loading />
                </div>
            ) : (
                <div className='first--cont'>
                    <div className='countries--container'>
                        <div className='grid--container'>
                            <p>Países</p>
                            <Grid data={paisesJefe.slice(page.skip, page.take + page.skip)} scrollable='none'
                                skip={page.skip}
                                take={page.take}
                                total={paisesJefe.length}
                                pageable={true}
                                onPageChange={pageChange}>
                                <GridColumn field="oidJefeEquipo" title="#"
                                cell={renderAutoIncrementCell}
                                width={20}/>
                                <GridColumn field="pais" title="País" />
                                <GridColumn field="codigo" title="Código" />
                                <GridColumn field="jefeEquipo" title="Jefe de equipo" />
                                <GridColumn field="active" title="Active"
                                width={20}/>
                                <GridColumn cell={editCountry} title="Acción"
                                width={20}/>
                            </Grid>
                            <div className='buttons-cont'>
                                <Link className="link--to--country" to="/admin-users">
                                    <button className="btn-back">Volver</button>
                                </Link >
                                <Link className="link--to--country" to="/admin-users/countries/create">
                                    <button className="btn-create">Crear País</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
